import { render } from "./RoleEdit.vue?vue&type=template&id=2959b99c"
import script from "./RoleEdit.vue?vue&type=script&lang=js"
export * from "./RoleEdit.vue?vue&type=script&lang=js"

import exportComponent from "D:\\LuisFolder\\project\\evcharge-ev-server-rocketmq\\evcharge-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__